import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAuth0 } from "@/auth/auth0-plugin"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComLoginButton',
  setup(__props) {

const auth0 = useAuth0()
const login = () => {
    if (!auth0) {
        return
    }

    const url: string | null = window.localStorage.getItem("targetUrl")
    const targetUrl = url
        ? {
                appState: {
                    targetUrl: url,
                },
            }
        : undefined

    auth0.login(targetUrl)
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    onClick: login,
    type: "success"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Kirjaudu sisään", -1)
    ]))]),
    _: 1
  }))
}
}

})